/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Step_Hours_ServiceInputs */

const en_platform_step_hours_service = /** @type {(inputs: Platform_Step_Hours_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1:1 session · 60 min`)
};

const pl_platform_step_hours_service = /** @type {(inputs: Platform_Step_Hours_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening 1:1 · 60 min`)
};

/**
* | output |
* | --- |
* | "1:1 session · 60 min" |
*
* @param {Platform_Step_Hours_ServiceInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_step_hours_service = /** @type {((inputs?: Platform_Step_Hours_ServiceInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Step_Hours_ServiceInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_step_hours_service(inputs)
	return en_platform_step_hours_service(inputs)
});